import { createColDef } from '@fortem-monorepo/react-ag'

import { ClientIdCellEditor } from '@/ag-grid/columns/client-id/cell-editor'
import { ClientIdCellRenderer } from '@/ag-grid/columns/client-id/renderer'

export const client_id = createColDef({
  field: 'client_id',
  headerName: 'Client',
  cellRenderer: ClientIdCellRenderer,
  cellEditor: ClientIdCellEditor,
  width: 200,
})
